<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle
      cx="12"
      cy="13"
      r="4"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCamera',
  props: {
    size: { type: [String, Number], default: 18 },
    strokeWidth: { type: [String, Number], default: 1.8 },
  },
};
</script>
